import React from 'react';
import { useContext } from 'react';
import { Search } from '../shared/Search';
import { ObjectSelector } from './ObjectSelector';
import { SearchContext } from './SearchContainer';
const { capitalCase } = require('change-case');
import './SearchBar.scss';

export const SearchBar = () => {
  const context = useContext(SearchContext);

  return (
    <div
      className={'searchBar-container'}
      id='searchBar'>
      <ObjectSelector />
      <Search
        className={'searchBar-input'}
        searchQuery={context.searchQuery}
        onSearchCallback={context.searchQueryCallback}
        searchPlaceholder={`Type to search ${capitalCase(context.searchObject?.pluralLabel)}...`}
      />
    </div>
  );
};
